import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { center, hstack, vstack } from '@flipster/styled-system/patterns';

import { RegisterButton } from '../../component/tc-button';
import { EventTitle } from '../event-title';
import { Rules } from '../rules';
import RewardsAirpods from './assets/rewards_airpods.webp';
import RewardsGift from './assets/rewards_gift.webp';
import RewardsIphone from './assets/rewards_iphone.webp';
import RewardsPa100 from './assets/rewards_pa100.webp';
import RewardsPa200 from './assets/rewards_pa200.webp';
import RewardsPa300 from './assets/rewards_pa300.webp';
import RewardsTb50 from './assets/rewards_tb50.webp';
import RewardsTb100 from './assets/rewards_tb100.webp';
import RewardsTb200 from './assets/rewards_tb200.webp';
import RewardsTb300 from './assets/rewards_tb300.webp';
import RewardsTb500 from './assets/rewards_tb500.webp';
import RewardsTravel from './assets/rewards_travel.webp';

export const XMasEtcContent = () => {
  return (
    <>
      <EventTitle />
      <ParticipantRewards />
      <Rules />
    </>
  );
};

const ParticipantRewards = () => {
  return (
    <section>
      <p className={css({ textStyle: 'Title/M', color: 'content.default.level-5', textAlign: 'center', pb: 40 })}>
        <FormattedMessage id='Competition.r251217.More_participants_more_rewards' />
      </p>
      <section className={vstack({ gap: 20, alignItems: 'flex-start' })}>
        {Object.entries(prizeList).map(([key, value]) => (
          <div key={key}>
            <p className={css({ textStyle: 'Title/XS', pb: 24 })}>
              <FormattedMessage
                id='Competition.r251217.If_number_participates'
                values={{ number: <Formatted.Number value={key} css={{ color: 'var(--key-color)' }} /> }}
              />
            </p>
            <ul className={hstack({ gap: 8, flexWrap: 'wrap' })}>
              {Object.entries(value).map(([label, { count, image }]) => (
                <li
                  key={label}
                  className={hstack({
                    w: { base: 143, tablet: 179 },
                    h: 100,
                    py: 8,
                    px: { base: 10, tablet: 16 },
                    rounded: 8,
                    bg: 'background.default.level-3',
                  })}
                >
                  <img src={image.src} alt={label} width={85} height={85} />
                  <Badge type='tint' color='promotion'>{`x${count}`}</Badge>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
      <div className={center({ mt: 40 })}>
        <RegisterButton buttonLocation='participant_rewards' />
      </div>
    </section>
  );
};

const prizeList = {
  500: {
    'iPhone 17 Pro': {
      count: 1,
      image: RewardsIphone,
    },
    'AirPods Pro': {
      count: 3,
      image: RewardsAirpods,
    },
    '$50 Trading bonus': {
      count: 10,
      image: RewardsTb50,
    },
  },
  1000: {
    'iPhone 17 Pro': {
      count: 2,
      image: RewardsIphone,
    },
    'AirPods Pro': {
      count: 5,
      image: RewardsAirpods,
    },
    '$200 PA': {
      count: 10,
      image: RewardsPa200,
    },
    '$100 PA': {
      count: 10,
      image: RewardsPa100,
    },
    '$50 Trading bonus': {
      count: 10,
      image: RewardsTb50,
    },
    'Flipster Christmas Gift': {
      count: 5,
      image: RewardsGift,
    },
  },
  1500: {
    'iPhone 17 Pro': {
      count: 3,
      image: RewardsIphone,
    },
    'AirPods Pro': {
      count: 5,
      image: RewardsAirpods,
    },
    '$300 PA': {
      count: 5,
      image: RewardsPa300,
    },
    '$200 PA': {
      count: 10,
      image: RewardsPa200,
    },
    '$100 Trading bonus': {
      count: 10,
      image: RewardsTb100,
    },
    'Flipster Christmas Gift': {
      count: 10,
      image: RewardsGift,
    },
  },
  2000: {
    'iPhone 17 Pro': {
      count: 3,
      image: RewardsIphone,
    },
    'AirPods Pro': {
      count: 10,
      image: RewardsAirpods,
    },
    '$300 PA': {
      count: 10,
      image: RewardsPa300,
    },
    '$200 PA': {
      count: 20,
      image: RewardsPa200,
    },
    '$100 Trading bonus': {
      count: 30,
      image: RewardsTb100,
    },
    'Flipster Christmas Gift': {
      count: 20,
      image: RewardsGift,
    },
  },
  5000: {
    '4 days Year-End Trip Package($3500)': {
      count: 2,
      image: RewardsTravel,
    },
    'iPhone 17 Pro': {
      count: 10,
      image: RewardsIphone,
    },
    'AirPods Pro': {
      count: 30,
      image: RewardsAirpods,
    },
    '$500 Trading bonus': {
      count: 10,
      image: RewardsTb500,
    },
    '$300 Trading bonus': {
      count: 10,
      image: RewardsTb300,
    },
    '$200 Trading bonus': {
      count: 100,
      image: RewardsTb200,
    },
    '$100 Trading bonus': {
      count: 200,
      image: RewardsTb100,
    },
    'Flipster Christmas Gift': {
      count: 50,
      image: RewardsGift,
    },
  },
};
